/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OtmId } from 'common-typescript/types';

@Component({
    selector: 'app-graduation-wizard-step1',
    templateUrl: './graduation-wizard-step1.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GraduationWizardStep1Component {
    @Input() organisationId: OtmId;
    @Input() stepNumber: number;
    @Output() forward = new EventEmitter<void>();
}
